import { getUsersLastContent } from "services/firebase";
import { statusType } from "types";

interface newFile extends File {
    originalname?: string;
}

function removeDotsExceptLast(inputString: string) {
    var lastDotIndex = inputString.lastIndexOf(".");
    var substringBeforeLastDot = inputString.slice(0, lastDotIndex).replace(/\./g, "");
    var substringAfterLastDot = inputString.slice(lastDotIndex);

    return substringBeforeLastDot + substringAfterLastDot;
}

export const processFileName = (file: File, contentId: string, originalname: string): File => {
    const newFileName = removeDotsExceptLast(`${contentId}_${file.name.substring(0, 24).replace(/\s/g, '_')}`);
    const newFile: newFile = new File([file], newFileName, { type: file.type });
    newFile.originalname = originalname; // fix because backend uses originalname
    return newFile;
}

export const setLogging = () => {
    if (process.env.NODE_ENV !== "development") {
        console.log = () => { };
        console.debug = () => { };
        console.info = () => { };
        console.warn = () => { };
    }
}

export const canNewFileBeUploaded = async (uid: string): Promise<boolean> => {
    const usersLastContent = await getUsersLastContent(uid);

    return !usersLastContent || usersLastContent.status === statusType.Translated || usersLastContent.status === statusType.Failed
        ? true : false;
}